import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../utility-services/auth.service';
import { HttpMainService } from '../../http-main.service';
import {
  ClientsListResponseModel,
  ListModel,
  ListRequestModel,
  UserResponseModel,
  UtmResponseModel
} from '@itb-monorepo/models';
import { Observable, of } from 'rxjs';
import { removeEmptyFields } from '@itb-monorepo/helper';


@Injectable()
export class SupporterUsersService {
  private _HttpMainService = inject(HttpMainService);
  private authService = inject(AuthService);
  baseUrl = '/member/';

  getUsersList(params?: ListRequestModel): Observable<ListModel<UserResponseModel>> {
    if (!this.authService.hasAccess('users:L'))
      return of();
    const url = `${this.baseUrl}v1/users`;
    return this._HttpMainService.get(url, removeEmptyFields(params));
  }

  getUserListExcel(params: any): Observable<any> {
    if (!this.authService.hasAccess('users:L'))
      return of();
    const url = `${this.baseUrl}v1/users`;
    return this._HttpMainService.getFile(url, 'application/csv', removeEmptyFields(params));
  }


  getUtmList(params: ListRequestModel): Observable<ListModel<UtmResponseModel>> {
    if (!this.authService.hasAccess('utm:L'))
      return of();
    const url = `${this.baseUrl}v1/utm`;
    return this._HttpMainService.get(url, removeEmptyFields(params));
  }
  getUtmListExcel(params: any): Observable<any> {
    if (!this.authService.hasAccess('utm:L'))
      return of();
    const url = `${this.baseUrl}v1/utm`;
    return this._HttpMainService.getFile(url, 'application/csv', removeEmptyFields(params));
  }

  addClient(user_id: string, introducer_user_id: string): Observable<ClientsListResponseModel>{
    if (!this.authService.hasAccess('clients:C'))
      return of();
    return this._HttpMainService.post(this.baseUrl + `v1/introducers/${introducer_user_id}/clients`, user_id);
  }
}
